import React from 'react'
import Layout from './../components/layout';
import {loadAllPayslips} from '../store'
import CheveronRight from 'material-ui/svg-icons/navigation/chevron-right';
import {List, ListItem} from 'material-ui/List';
import {browserHistory} from 'react-router'
import { niceNumber } from '../components/payslip';
import FlatButton from 'material-ui/FlatButton';
import {get} from '../components/utils'
import store from '../store'
import CircularProgress from 'material-ui/CircularProgress';
import PageviewGA from '../components/pageview-ga'
import ReactGA from 'react-ga'

class Body extends React.Component {

    constructor() {
        super()
        this.state = {show_spinner: false, error: false, success: false}
    }

    view(id) {
        browserHistory.push( `/payslip/${id}`)
    }


    loadMorePayslips() {
        const payslips = this.props.store.all_payslips
        if(payslips.has_next_page && payslips.next_page){
            this.setState( {show_spinner: true, error: "", success: false} )
            ReactGA.event({category: 'Payslips', action: 'Load more', label: ''})
            get( "/api/epayslips/payslips?cursor="+payslips.next_page).then( (data) => {
                if ( data.treat_as_error ) {
                    this.setState( {show_spinner: false, error: "Error loading more. Please try again.", success: false} )
                }
                else {
                    store.dispatch( {
                        type: "DATA_PUSH_ITEMS",
                        data: {"all_payslips": data}
                    } )
                    this.setState( {show_spinner: false, error: false, success: true} )
                }
            })
        }
    }


    render() {
        return (
            <div className="all-payslips gutters">
                <List>
                    { this.props.store.all_payslips.items.map( (row) => {
                        const node = <div className="layout-row flex layout-justify-space-between">
                            <div>{row.due_date}</div>
                            <div>{niceNumber(row.net_pay)}</div>
                        </div>
                        return <ListItem id={`payslip_${row.due_date.replace(/\//g, "_")}`} key={row.id} onClick={() => this.view(row.id)} primaryText={node} rightIcon={<CheveronRight/>} />
                    })}
                </List>
                <div className="layout-column layout-align-center-center">
                    {this.state.error ? <div className="error">{this.state.error}</div> : <br/>}
                    {this.state.show_spinner ? 
                        <div className="spinner">
                            <CircularProgress size={40} thickness={4} />
                        </div>
                        :
                        this.props.store.all_payslips.has_next_page ? 
                            <FlatButton className="load_more" label="LOAD MORE" primary={true} onClick={() => this.loadMorePayslips()}/>
                            :
                            <br/>
                    }
                </div>
             </div>
        )
    }

}


export default class extends React.Component {

    constructor() {
        super();
        loadAllPayslips()
    }


    render() {
        let payslips = this.props.store.all_payslips
        let errorMessage = null

        if ( payslips.treat_as_error) errorMessage =  "Error retrieving payslip information"

        if ( payslips.ready && !payslips.treat_as_error &&  !payslips.items ) {
            errorMessage = "You do not have any payslips yet"
        }


        return (
            <div className="layout-row flex">
                <PageviewGA/>
                <Layout title="All Payslips"
                        showAppBarActions={false}
                        {...this.props}
                        ready={this.props.store.all_payslips.ready}
                        errorMessage={errorMessage}
                        body={Body}>
                </Layout>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/pages/all_payslips.js